import { Card, CardBody, CardFooter, CardHeader, Button, Text, Heading, Box } from "grommet";
import { Document, View } from "grommet-icons";

export interface AlgorithmCardProps {
  selectedModel: any;
}

export const AlgorithmCard = ({ selectedModel }: AlgorithmCardProps) => {
  return Object.keys(selectedModel).length > 1 ? (
    <Card height="xlarge" background="light-1">
      <CardHeader pad="small" direction="row" justify="between" background="light-2">
        <Heading color="brand" level={3} size="xsmall" margin="none">
          {selectedModel.label.split("/")[0]}
        </Heading>
        <Heading color="brand" level={3} size="xsmall" margin="none">
          {selectedModel.label.split("/")[1]}
        </Heading>
      </CardHeader>
      <CardBody pad="small" overflow="scroll">
        <Heading level={4} size="xsmall" margin="none">
          Applicable patient group
        </Heading>
        <Text>{selectedModel.patientGroup}</Text>
        <Heading level={4} size="xsmall" margin={{ top: "small", bottom: "xxsmall" }}>
          Predicted outcome
        </Heading>
        <Text>{selectedModel.predictedOutcome}</Text>
        <Heading level={4} size="xsmall" margin={{ top: "small", bottom: "xxsmall" }}>
          Baseline value in this population
        </Heading>
        <Text>{selectedModel.baseValue}%</Text>
        <Heading level={4} size="xsmall" margin={{ top: "small", bottom: "xxsmall" }}>
          Background
        </Heading>
        <Text>{selectedModel.paper.text}</Text>
      </CardBody>
      <CardFooter pad="small" background="light-2">
        <Box background="orange" round="medium" pad={{ horizontal: "small", vertical: "xsmall" }}>
          <Text size="small">Research-use only</Text>
        </Box>
        <Button plain icon={<View />} href={selectedModel.link} />
        <Button plain icon={<Document />} href={selectedModel.paper.link} />
      </CardFooter>
    </Card>
  ) : (
    <Box></Box>
  );
};
